// client/plugins/ObsidianLinkPlugin/helper/getFilteredLinks.ts
var getFilteredLinks = (linkList, search) => {
  const filteredLinks = search === "" ? linkList : linkList.filter(
    (link) => link.href.toLowerCase().includes(search.toLowerCase()) || link.name.toLowerCase().includes(search.toLowerCase())
  );
  return filteredLinks;
};
export {
  getFilteredLinks
};
